import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from "prop-types";
import React, { Component } from "react";
import classNames from "classnames";
import { getRehydratableName, getClassNameFactory } from "../../utilities";
import contextTypes from "./contextTypes";
import Panel from "./components/Panel";
import Tab from "./components/Tab";
import TabList from "./components/TabList";
import SelectControl from "../Form/components/SelectControl";

var Tabs = /*#__PURE__*/function (_Component) {
  _inherits(Tabs, _Component);

  var _super = _createSuper(Tabs);

  function Tabs(props) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleWindowResize", function () {
      if (window && window.innerWidth) {
        _this.setState(function (state) {
          return _objectSpread(_objectSpread({}, state), {}, {
            isMobile: window.innerWidth < _this.mobileScreenBreakpoint
          });
        });
      }

      if (_this.tabsRef) {
        _this.tabsRef.style = "display:block;";

        var overflown = _this.isOverflown(_this.tabsRef);

        _this.tabsRef.style = "";

        _this.setState({
          overflown: overflown
        });
      }
    });

    _this.getClassName = getClassNameFactory(Tabs.displayName);
    var tabs = Tabs.getTabs(props.children);
    _this.state = {
      currentOpenPanel: props.defaultTab || tabs[0] && tabs[0].relatedId || null,
      tabs: tabs,
      isMobile: false,
      overflown: false
    };
    _this.mobileScreenBreakpoint = 768;
    _this.updateFromHash = _this.updateFromHash.bind(_assertThisInitialized(_this));
    _this.handleTabClick = _this.handleTabClick.bind(_assertThisInitialized(_this));
    _this.handleTabListKeyDown = _this.handleTabListKeyDown.bind(_assertThisInitialized(_this));
    _this.setOpenPanel = _this.setOpenPanel.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Tabs, [{
    key: "isOverflown",
    value: function isOverflown(e) {
      return e.scrollWidth > e.clientWidth;
    }
  }, {
    key: "getChildContext",
    value: function getChildContext() {
      // We carefully considered the use of context here. In the case of Tabs,
      // it simplifies the logic for rehydration, reduces coupling between
      // components, and eliminates hidden props. React have suggested that this
      // API may change in the future; if and when that happens, we need to
      // update our implementation to match.
      return {
        currentOpenPanel: this.state.currentOpenPanel
      };
    }
  }, {
    key: "setOpenPanel",
    value: function setOpenPanel(panelId) {
      var _this$state = this.state,
          tabs = _this$state.tabs,
          currentOpenPanel = _this$state.currentOpenPanel;
      var handleTabChange = this.props.handleTabChange;
      this.setState({
        currentOpenPanel: panelId
      });
      Tabs.setLocationHash(panelId);
      var tabIndex = tabs.findIndex(function (tab) {
        return tab.relatedId === panelId;
      });
      var tab = tabs[tabIndex];

      if (handleTabChange) {
        handleTabChange(panelId, currentOpenPanel);
      }

      this.props.analytics("Tab navigation", "Click ".concat(tabIndex + 1), tab.title, panelId);
    }
  }, {
    key: "handleTabListKeyDown",
    value: function handleTabListKeyDown(e) {
      var _this2 = this;

      var currentOpenPanelIndex = this.state.tabs.findIndex(function (tab) {
        return tab.relatedId === _this2.state.currentOpenPanel;
      });
      var desktopViewportWidth = 768;
      var direction = getComputedStyle(this.ref).direction;
      var homeKey = "Home";
      var endKey = "End";
      var upKey = "ArrowUp";
      var downKey = "ArrowDown";
      var nextKey = direction === "ltr" ? "ArrowRight" : "ArrowLeft";
      var previousKey = direction === "ltr" ? "ArrowLeft" : "ArrowRight";
      var focusPanelKey = "--disabled--";

      if (this.props.layoutVariant === "verticalAtDesktop" && window.innerWidth >= desktopViewportWidth) {
        nextKey = "ArrowDown";
        previousKey = "ArrowUp";
        focusPanelKey = direction === "ltr" ? "ArrowRight" : "ArrowLeft";
      }

      if ([nextKey, previousKey, homeKey, endKey, upKey, downKey].includes(e.key)) {
        e.preventDefault();
        var tabsHome = 0;
        var tabsEnd = this.state.tabs.length - 1;
        var nextPanel = 0;
        var newOpenPanel;

        switch (e.key) {
          case previousKey:
          case upKey:
            nextPanel = this.getNextEnableTab(currentOpenPanelIndex, "up");

            if (nextPanel === null) {
              nextPanel = currentOpenPanelIndex;
            }

            newOpenPanel = this.state.tabs[nextPanel].relatedId;
            break;

          case nextKey:
          case downKey:
            nextPanel = this.getNextEnableTab(currentOpenPanelIndex, "down");

            if (nextPanel === null) {
              nextPanel = currentOpenPanelIndex;
            }

            newOpenPanel = this.state.tabs[nextPanel].relatedId;
            break;

          case homeKey:
            newOpenPanel = this.state.tabs[tabsHome].relatedId;
            break;

          case endKey:
            newOpenPanel = this.state.tabs[tabsEnd].relatedId;
            break;
        }

        this.setOpenPanel(newOpenPanel);
      } else if (e.key === focusPanelKey) {
        // See https://inclusive-components.design/tabbed-interfaces/#aproblemreadingpanels
        this.ref.querySelector("#".concat(this.state.currentOpenPanel, "-tab")).focus();
      }
    }
  }, {
    key: "getNextEnableTab",
    value: function getNextEnableTab(currentOpenPanelIndex, dir) {
      var tabsHome = 0;
      var tabsEnd = this.state.tabs.length - 1;
      var nextTabIndex = dir === "up" ? Math.max(tabsHome, currentOpenPanelIndex - 1) : Math.min(currentOpenPanelIndex + 1, tabsEnd);

      if (this.props.enableArrowKeyCarousel === true && nextTabIndex === currentOpenPanelIndex) {
        nextTabIndex = dir === "up" ? tabsEnd : tabsHome;
      }

      var nextTab = this.state.tabs[nextTabIndex];

      if (nextTab.disabled && (nextTabIndex === tabsHome || nextTabIndex === tabsEnd) && this.props.enableArrowKeyCarousel !== true) {
        return null;
      }

      if (nextTab.disabled) {
        return this.getNextEnableTab(nextTabIndex, dir);
      }

      return nextTabIndex;
    }
  }, {
    key: "handleTabClick",
    value: function handleTabClick(e, relatedId) {
      if (e) {
        e.preventDefault();
      }

      this.setOpenPanel(relatedId);
    } // This function returns the size of the header, if the header is 'above' the given
    // position in the whole document. If the header is below, return 0.

  }, {
    key: "updateFromHash",
    value: function updateFromHash() {
      var locationHash = Tabs.getLocationHash();

      if (locationHash && this.state.tabs.map(function (tab) {
        return tab.relatedId;
      }).includes(locationHash)) {
        this.setOpenPanel(locationHash);
        var elementPosition = this.ref.getBoundingClientRect().top + window.pageYOffset; // wait until after window does its usual scroll to button

        setTimeout(function () {
          window.scrollTo(0, elementPosition - Tabs.calculateHeaderOffset(elementPosition));
        }, 0);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleWindowResize();
      this.updateFromHash();

      if (window) {
        window.addEventListener("resize", this.handleWindowResize);
        window.addEventListener("hashchange", this.updateFromHash);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProp) {
      if (prevProp !== this.props) {
        var newState = {
          tabs: Tabs.getTabs(this.props.children)
        };

        if (newState.tabs.length === 0) {
          newState.currentOpenPanel = null;
        } else if (!newState.tabs.map(function (tab) {
          return tab.relatedId;
        }).includes(this.state.currentOpenPanel)) {
          // The previously open tab no longer exists. Open either the default tab,
          // or the first tab if no default is set.
          newState.currentOpenPanel = this.props.defaultTab || newState.tabs[0].relatedId;
        }

        this.setState(newState);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (window) {
        window.removeEventListener("hashchange", this.updateFromHash);
        window.removeEventListener("resize", this.handleWindowResize);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          children = _this$props.children,
          defaultTab = _this$props.defaultTab,
          layoutVariant = _this$props.layoutVariant,
          ariaLabelText = _this$props.ariaLabelText,
          dropdownLabelText = _this$props.dropdownLabelText;
      var _this$state2 = this.state,
          isMobile = _this$state2.isMobile,
          tabs = _this$state2.tabs,
          overflown = _this$state2.overflown;
      var tabsOptions = tabs.map(function (tab) {
        return {
          value: tab.relatedId,
          label: tab.title,
          disabled: tab.disabled,
          segment: tab.segment,
          subsegment: tab.subSegment
        };
      });
      var showMobileUI = isMobile || overflown;
      return /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          modifiers: classNames(layoutVariant, {
            mobile: showMobileUI
          })
        }),
        "data-default-tab": defaultTab,
        "data-layout-variant": layoutVariant,
        "data-rehydratable": getRehydratableName(Tabs.displayName),
        "data-rehydratable-children-selector": ".".concat(this.getClassName({
          descendantName: "panel"
        })),
        ref: function ref(_ref2) {
          return _this3.ref = _ref2;
        }
      }, !isMobile && /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "list",
          modifiers: classNames({
            visible: !overflown
          })
        }),
        ref: function ref(_ref) {
          return _this3.tabsRef = _ref;
        }
      }, /*#__PURE__*/React.createElement(TabList, {
        layoutVariant: layoutVariant,
        horizontalTabsActions: !this.props.layoutVariant && this.props.horizontalTabsActions,
        ariaLabelText: ariaLabelText
      }, this.state.tabs.map(function (tab) {
        return /*#__PURE__*/React.createElement(Tab, _extends({}, tab, {
          key: tab.relatedId,
          layoutVariant: layoutVariant,
          onClick: _this3.handleTabClick,
          onKeyDown: _this3.handleTabListKeyDown,
          selected: tab.relatedId === _this3.state.currentOpenPanel
        }));
      }))), showMobileUI && /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "select"
        })
      }, /*#__PURE__*/React.createElement(SelectControl, {
        placeholder: false,
        labelText: dropdownLabelText,
        optionalText: "",
        options: tabsOptions,
        value: this.state.currentOpenPanel,
        id: this.state.currentOpenPanel,
        onChange: function onChange(option) {
          return _this3.handleTabClick(null, option.value);
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "panel"
        })
      }, children));
    }
  }], [{
    key: "getTabs",
    value: function getTabs(children) {
      var tabs = [];
      React.Children.forEach(children, function (child) {
        if ((child === null || child === void 0 ? void 0 : child.type) === Panel) {
          var _child$props = child.props,
              tabTitle = _child$props.tabTitle,
              id = _child$props.id,
              dataAttribute = _child$props.dataAttribute,
              segment = _child$props.segment,
              subSegment = _child$props.subSegment,
              _child$props$disabled = _child$props.disabled,
              disabled = _child$props$disabled === void 0 ? false : _child$props$disabled;
          tabs.push(_objectSpread({
            title: tabTitle,
            relatedId: id,
            segment: segment,
            subSegment: subSegment,
            disabled: disabled
          }, dataAttribute && {
            dataAttribute: dataAttribute
          }));
        } else if ((child === null || child === void 0 ? void 0 : child.type) === React.Fragment) {
          tabs.push.apply(tabs, _toConsumableArray(Tabs.getTabs(child.props.children)));
        }
      });
      return tabs;
    }
  }, {
    key: "calculateHeaderOffset",
    value: function calculateHeaderOffset(position) {
      var headers = document.querySelectorAll("[class$=--sticky]");

      for (var i = 0; i < headers.length; i++) {
        var header = headers[i]; // check if the header is at the top of the page

        if (header.getBoundingClientRect().top + window.pageYOffset <= position) {
          return header.offsetHeight;
        }
      }

      return 0;
    }
  }]);

  return Tabs;
}(Component);

_defineProperty(Tabs, "displayName", "Tabs");

_defineProperty(Tabs, "childContextTypes", contextTypes);

_defineProperty(Tabs, "propTypes", {
  /**
   * An analytics function, accepting category, action, and label as arguments.
   */
  analytics: PropTypes.func,

  /**
   * The content of the tabs. These should be of type `Tabs.Picker` or `Tabs.Panel`.
   */
  children: PropTypes.node,

  /**
   * The ID of the default tab to open. This will be used if no ID was found in the URL that exists in this set of tabs. If none is specified, the first tab panel will be used as the default.
   */
  defaultTab: PropTypes.string,

  /**
   * If changing to different tab pass in optional function.  This passes two parameters, one for id of tabbed clicked, and one for id of current tab.
   */
  handleTabChange: PropTypes.func,

  /**
   * Optional modifier to switch layout variants
   */
  layoutVariant: PropTypes.oneOf(["verticalAtDesktop"]),

  /**
   * Prop to render right-side components inside horizontal tabs row
   */
  horizontalTabsActions: PropTypes.node,

  /**
   * aria-label text for the tab list
   */
  ariaLabelText: PropTypes.string,

  /**
   * Optional label for SelectControl in mobile view
   */
  dropdownLabelText: PropTypes.string,

  /**
   * Enable carousel focus using the arrow keys
   */
  enableArrowKeyCarousel: PropTypes.bool
});

_defineProperty(Tabs, "defaultProps", {
  analytics: function analytics() {},
  enableArrowKeyCarousel: true
});

_defineProperty(Tabs, "getLocationHash", function () {
  if (window && window.location && window.location.hash) {
    return window.location.hash.substr(1);
  }

  return null;
});

_defineProperty(Tabs, "setLocationHash", function (hash) {
  if (history && history.pushState) {
    history.replaceState(null, "", "#".concat(hash));
  }
});

Tabs.Panel = Panel;
export default Tabs;